import RouteTemplate from 'ember-route-template';

import Component from '@glimmer/component';

import PageNotFound from 'rise-ui/components/page-not-found.gjs';

export default RouteTemplate(class PageNotFoundTemplate extends Component {
  <template>
    <PageNotFound />
    {{outlet}}
  </template>
});
